import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const CreateCaseModal = ({ workspaceId, onClose, onSubmit }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    time_horizon: '',
    category_system: 'PESTEL',
    custom_categories: []
  });
  const [loading, setLoading] = useState(false);

  const categorySystems = [
    'PESTEL',
    'PESTE',
    'PEST',
    'SWOT',
    'Cybersecurity Framework',
    'Custom'
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      await onSubmit({ ...formData, workspace_id: workspaceId });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-neutral-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
      <div className="relative top-20 mx-auto p-6 border border-neutral-200 w-96 rounded-lg bg-white">
        <div>
          <h3 className="text-lg font-medium text-neutral-900 mb-4">
            {t('cases.createTitle')}
          </h3>
          
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-neutral-700">
                {t('cases.name')}
              </label>
              <input
                type="text"
                name="name"
                required
                value={formData.name}
                onChange={handleChange}
                placeholder={t('cases.namePlaceholder')}
                className="mt-1 block w-full border-neutral-300 rounded-md shadow-sm focus:ring-accent-500 focus:border-accent-500 sm:text-sm"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-neutral-700">
                {t('common.description')}
              </label>
              <textarea
                name="description"
                rows={3}
                value={formData.description}
                onChange={handleChange}
                placeholder={t('cases.descriptionPlaceholder')}
                className="mt-1 block w-full border-neutral-300 rounded-md shadow-sm focus:ring-accent-500 focus:border-accent-500 sm:text-sm"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-neutral-700">
                {t('cases.timeHorizon')}
              </label>
              <input
                type="text"
                name="time_horizon"
                value={formData.time_horizon}
                onChange={handleChange}
                placeholder={t('cases.timeHorizonPlaceholder')}
                className="mt-1 block w-full border-neutral-300 rounded-md shadow-sm focus:ring-accent-500 focus:border-accent-500 sm:text-sm"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-neutral-700">
                {t('cases.analysisFramework')}
              </label>
              <select
                name="category_system"
                value={formData.category_system}
                onChange={handleChange}
                className="mt-1 block w-full border-neutral-300 rounded-md shadow-sm focus:ring-accent-500 focus:border-accent-500 sm:text-sm"
              >
                {categorySystems.map(system => (
                  <option key={system} value={system}>{system}</option>
                ))}
              </select>
            </div>

            <div className="flex justify-end space-x-3 pt-4">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 border border-neutral-300 rounded-md text-sm font-medium text-neutral-700 bg-white hover:bg-neutral-50 transition-colors"
              >
                {t('common.cancel')}
              </button>
              <button
                type="submit"
                disabled={loading}
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-accent-600 hover:bg-accent-700 transition-colors disabled:opacity-50"
              >
                {loading ? t('cases.creating') : t('cases.create')}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateCaseModal;